.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.inner {
    grid-column: 1 / -1;
    height: 750px;
}
